import clsx from 'clsx';

interface DotSymbolProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function DotSymbol({ className, size = 'md' }: DotSymbolProps) {
  return (
    <svg
      viewBox="0 0 4 4"
      className={clsx(
        'flex-none',
        size === 'sm' && 'size-1',
        size === 'md' && 'size-1.5',
        size === 'lg' && 'size-2',
        className
      )}
    >
      <circle fill="currentColor" cx={2} cy={2} r={1} />
    </svg>
  );
}
